import { Confirm } from 'components';
import {
  AddDepartmentMarket,
  AddEditMarkets,
  AddEditOperationalClientOffice,
  AddEditOperationalThirdParty,
  AddEditOperationalThirdPartyOffice,
  AddEditParentClient,
  AddEditQuoteBind,
  AddEditReport,
  AddEditReportGroup,
  AddInsured,
  AddLayer,
  AddMarket,
  AddPlacementLayer,
  AddPlacementLayerMarket,
  AddProductsCarrier,
  AddProductsClient,
  AddProductsFacility,
  AddProductsInsured,
  AddUser,
  AssignToFacilityGroup,
  BulkUpdateLayer,
  BulkUpdatePolicy,
  ConfirmDecline,
  ConfirmDelete,
  ConfirmUnBound,
  CreateInWhitespace,
  DocumentUpload,
  DownloadBordereaux,
  DownloadFiles,
  EditDepartmentMarket,
  EditEndorsementQuote,
  EditEndorsementQuoteProRata,
  EditLayersRiskQuote,
  EditPlacement,
  EditPlacementLayer,
  EditPlacementMarketsLayers,
  EditPolicy,
  EditPostQuoteOptions,
  EditProductsClient,
  EditProductsInsured,
  EditQuote,
  EditRiskQuote,
  ExtendCancelPolicy,
  ModellingTask,
  NewEnquiry,
  PreBindQuote,
  SignDown
} from 'forms';
import { PasteFromExcel } from 'modules';

export const MODALS = {
  ADD_DEPARTMENT_MARKET: AddDepartmentMarket,
  ADD_EDIT_OPERATIONAL_CLIENT_OFFICE: AddEditOperationalClientOffice,
  ADD_EDIT_PARENT_CLIENT: AddEditParentClient,
  ADD_EDIT_OPERATIONAL_MARKET: AddEditMarkets,
  ADD_EDIT_OPERATIONAL_THIRD_PARTY: AddEditOperationalThirdParty,
  ADD_EDIT_OPERATIONAL_THIRD_PARTY_OFFICE: AddEditOperationalThirdPartyOffice,
  ADD_USER: AddUser,
  ADD_EDIT_QUOTE_BIND: AddEditQuoteBind,
  ADD_INSURED: AddInsured,
  ADD_LAYER: AddLayer,
  ADD_MARKET: AddMarket,
  ADD_PLACEMENT_LAYER: AddPlacementLayer,
  ADD_PLACEMENT_LAYER_MARKET: AddPlacementLayerMarket,
  ADD_PRODUCTS_CLIENT: AddProductsClient,
  ADD_PRODUCTS_CARRIER: AddProductsCarrier,
  ADD_PRODUCTS_FACILITY: AddProductsFacility,
  ASSIGN_TO_FACILITY_GROUP: AssignToFacilityGroup,
  ADD_PRODUCTS_INSURED: AddProductsInsured,
  EDIT_RISK_QUOTE: EditRiskQuote,
  EDIT_ENDORSEMENT_QUOTE: EditEndorsementQuote,
  EDIT_ENDORSEMENT_QUOTE_PRO_RATA: EditEndorsementQuoteProRata,
  BULK_UPDATE_LAYER: BulkUpdateLayer,
  BULK_UPDATE_POLICY: BulkUpdatePolicy,
  CONFIRM: Confirm,
  CONFIRM_DELETE: ConfirmDelete,
  CONFIRM_DECLINE_RISK: ConfirmDecline,
  EXTEND_CANCEL_POLICY: ExtendCancelPolicy,
  CONFIRM_UNBOUND: ConfirmUnBound,
  CREATE_IN_WHITESPACE: CreateInWhitespace,
  DOCUMENT_UPLOAD: DocumentUpload,
  DOWNLOAD_BORDEREAUX: DownloadBordereaux,
  DOWNLOAD_FILES: DownloadFiles,
  EDIT_DEPARTMENT_MARKET: EditDepartmentMarket,
  EDIT_PLACEMENT_LAYER: EditPlacementLayer,
  EDIT_PLACEMENT_MARKETS_LAYERS: EditPlacementMarketsLayers,
  EDIT_POLICY: EditPolicy,
  EDIT_PLACEMENT: EditPlacement,
  EDIT_PRODUCTS_CLIENT: EditProductsClient,
  EDIT_PRODUCTS_INSURED: EditProductsInsured,
  EDIT_QUOTE: EditQuote,
  MODELLING_TASK: ModellingTask,
  NEW_ENQUIRY: NewEnquiry,
  PASTE_FROM_EXCEL: PasteFromExcel,
  SIGN_DOWN: SignDown,
  ADD_EDIT_REPORT: AddEditReport,
  ADD_EDIT_REPORT_GROUP: AddEditReportGroup,
  PRE_BIND_QUOTE: PreBindQuote,
  EDIT_LAYERS_RISK_QUOTE: EditLayersRiskQuote,
  EDIT_POST_QUOTE_OPTIONS: EditPostQuoteOptions,
} as const;
